export interface Page404Props {

}

const Page404 = () => {
  return (<>page 404</>);
}

export default Page404;